const formatDecimalNumber = (num: number, decimals = 2): string => 
    Number.isInteger(num) ? num.toString() : num.toFixed(decimals);

export default formatDecimalNumber;